import React from "react";
import Explain from "../../atoms/Explain";
import { ValidationType } from "../../atoms/Explain/types";
import { StyledContainer, StyledExplainWrapper } from "./styles";

export interface ExplainWrapperProps {
  status?: ValidationType;
  isNotShowText?: boolean;
}

const ExplainWrapper: React.FC<ExplainWrapperProps> = ({
  status,
  children,
  isNotShowText,
}) => {
  return (
    <StyledContainer>
      {children}
      <StyledExplainWrapper>
        {status?.status !== undefined && status?.explain !== undefined && (
          <Explain
            isNotShowText={isNotShowText}
            explain={status.explain}
            status={status.status}
          />
        )}
      </StyledExplainWrapper>
    </StyledContainer>
  );
};
ExplainWrapper.defaultProps = {
  status: { status: undefined, explain: undefined },
};

export default ExplainWrapper;
